var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAnnotation = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_93313)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint0_linear_119_93313)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint1_radial_119_93313)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint2_radial_119_93313)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint3_radial_119_93313)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint4_radial_119_93313)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint5_radial_119_93313)",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint6_radial_119_93313)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 52,
    height: 52,
    rx: 5.70798,
    fill: "url(#paint7_radial_119_93313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint8_linear_119_93313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint9_radial_119_93313)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint10_radial_119_93313)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint11_radial_119_93313)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint12_radial_119_93313)",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    fill: "url(#paint13_radial_119_93313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.671 31.3213C26.6359 31.3254 26.605 31.3207 26.5689 31.3049C26.5538 31.1425 26.5796 30.7981 26.7738 30.2389C27.0391 29.475 27.5262 28.5711 28.1639 27.6369C28.1473 27.9698 28.1253 28.2904 28.0997 28.5933C27.9953 29.8279 27.5025 30.6887 27.0634 31.0856C26.8586 31.2708 26.7349 31.3139 26.671 31.3213ZM37.7153 17.6261C38.5229 16.8725 38.5667 15.607 37.8131 14.7994C37.0595 13.9918 35.7939 13.948 34.9864 14.7016C33.9747 15.6456 32.3096 17.2328 30.6344 18.9003C30.0947 18.0107 29.3539 17.228 28.3336 16.7272C26.0546 15.6087 23.207 16.1815 20.7411 17.7511C18.2062 19.3646 15.7685 22.1828 13.9785 26.2423C10.5647 33.9842 9.74084 41.7624 13.887 47.3102C15.9802 50.1111 18.8806 51.6459 22.2639 51.7969C25.5675 51.9444 29.1623 50.7702 32.8096 48.5354C33.7515 47.9583 34.0472 46.727 33.4701 45.7852C32.893 44.8433 31.6617 44.5477 30.7198 45.1247C27.4889 47.1044 24.6866 47.9011 22.4423 47.8009C20.2777 47.7043 18.4794 46.7733 17.0911 44.9157C14.2738 41.146 14.4053 35.1883 17.6385 27.8562C19.172 24.3784 21.1406 22.2383 22.889 21.1255C24.7042 19.97 26.0172 20.0461 26.5712 20.318C26.9158 20.4872 27.3277 20.9688 27.6537 21.9675C27.0905 22.5741 26.5851 23.1414 26.1768 23.6353C24.8492 25.2412 23.6152 27.1413 22.9952 28.9266C22.6868 29.8146 22.4753 30.8288 22.6035 31.8326C22.7419 32.9167 23.2812 33.9543 24.3448 34.6361C26.2848 35.8797 28.3672 35.2992 29.7458 34.0529C31.0717 32.8544 31.9124 30.9783 32.0855 28.9301C32.2178 27.3648 32.2793 25.2378 32.0029 23.202C34.0189 21.1348 36.3815 18.8707 37.7153 17.6261Z",
    stroke: "#F2F1F3",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2318 12.0687C56.0404 9.59962 51.4531 10.185 48.984 13.3764L45.9086 17.3514L35.0141 31.4329C30.9659 36.6653 29.1629 43.2905 30.0001 49.8518C36.5614 49.0145 42.5227 45.6054 46.5697 40.3731L57.2534 26.564L60.5395 22.3166C63.0086 19.1252 62.4233 14.5379 59.2318 12.0687Z",
    fill: "url(#paint14_radial_119_93313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2318 12.0687C56.0404 9.59962 51.4531 10.185 48.984 13.3764L45.9086 17.3514L35.0141 31.4329C30.9659 36.6653 29.1629 43.2905 30.0001 49.8518C36.5614 49.0145 42.5227 45.6054 46.5697 40.3731L57.2534 26.564L60.5395 22.3166C63.0086 19.1252 62.4233 14.5379 59.2318 12.0687Z",
    fill: "url(#paint15_radial_119_93313)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2318 12.0687C56.0404 9.59962 51.4531 10.185 48.984 13.3764L45.9086 17.3514L35.0141 31.4329C30.9659 36.6653 29.1629 43.2905 30.0001 49.8518C36.5614 49.0145 42.5227 45.6054 46.5697 40.3731L57.2534 26.564L60.5395 22.3166C63.0086 19.1252 62.4233 14.5379 59.2318 12.0687Z",
    fill: "url(#paint16_linear_119_93313)",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2318 12.0687C56.0404 9.59962 51.4531 10.185 48.984 13.3764L45.9086 17.3514L35.0141 31.4329C30.9659 36.6653 29.1629 43.2905 30.0001 49.8518C36.5614 49.0145 42.5227 45.6054 46.5697 40.3731L57.2534 26.564L60.5395 22.3166C63.0086 19.1252 62.4233 14.5379 59.2318 12.0687Z",
    fill: "url(#paint17_radial_119_93313)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2318 12.0687C56.0404 9.59962 51.4531 10.185 48.984 13.3764L45.9086 17.3514L35.0141 31.4329C30.9659 36.6653 29.1629 43.2905 30.0001 49.8518C36.5614 49.0145 42.5227 45.6054 46.5697 40.3731L57.2534 26.564L60.5395 22.3166C63.0086 19.1252 62.4233 14.5379 59.2318 12.0687Z",
    fill: "url(#paint18_radial_119_93313)",
    fillOpacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_119_93313",
    x1: 52.8485,
    y1: 4.70886,
    x2: -4.82019,
    y2: 92.0072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.40601,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664211,
    stopColor: "#C9F5FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.625 33.125) rotate(-57.5674) scale(14.2176 13.2106)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323529,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.539216,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.625 20.5) rotate(136.922) scale(13.1773 7.17226)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.241969,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.614858,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.75 48) rotate(24.5901) scale(16.2211 10.6343)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481707,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744309,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.875 44.375) rotate(22.8336) scale(12.8847 6.60197)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.481707,
    stopColor: "#E0EAEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744309,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.25 20.625) rotate(14.3646) scale(10.5808 9.8314)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247064,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627193,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48 42) rotate(159.085) scale(42.0186 13.2281)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.457404,
    stopColor: "#909090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627193,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.75 32.875) rotate(137.358) scale(30.0775 20.8212)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.291314,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.627193,
    stopColor: "#E7E7E7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_119_93313",
    x1: 26.2498,
    y1: 7.74994,
    x2: 21.9998,
    y2: 66.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.212829,
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375473,
    stopColor: "#FF8039"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.522769,
    stopColor: "#FF86B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.690565,
    stopColor: "#B976EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.827863,
    stopColor: "#BB7AED"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4543 43.25) rotate(-15.8259) scale(14.209 10.3297)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.616964,
    stopColor: "#4A0A7C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.772706,
    stopColor: "#BA77ED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.9998 30.6875) rotate(-68.1986) scale(4.71202 2.38486)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.519705,
    stopColor: "#CA2B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926108,
    stopColor: "#FF835D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9998 25.6875) rotate(-44.7603) scale(10.5625 4.07771)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.371561,
    stopColor: "#CA2B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.926108,
    stopColor: "#FF835D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.7498 48) rotate(-70.2717) scale(42.0295 18.97)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.708782,
    stopColor: "#FFBA02",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7718,
    stopColor: "#DD5B16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2498 21) rotate(-48.6522) scale(10.4068 4.19299)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331565,
    stopColor: "#FFBA02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85252,
    stopColor: "#FFBA02",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.0853 43.8694) rotate(-69.437) scale(53.8978 39.1689)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.189078,
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#FFAA00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.651042,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802083,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AE1007"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3125 53.2302) rotate(-45.3244) scale(19.6113 10.9591)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.552308,
    stopColor: "#E96200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6B00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_119_93313",
    x1: 57.6175,
    y1: 29.5051,
    x2: 41.7522,
    y2: 23.0239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0999285,
    stopColor: "#AE1007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.880944,
    stopColor: "#AE1007",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.2274 14.6994) rotate(138.096) scale(7.09021 9.70304)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372713,
    stopColor: "#FF6B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.671875,
    stopColor: "#E73700",
    stopOpacity: 0.543009
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.958965,
    stopColor: "#D30202",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_119_93313",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5663 12.2305) rotate(125.698) scale(5.03475 8.71024)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.255208,
    stopColor: "#FFC37E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "#FF9C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C29",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_93313"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnnotation, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Annotation.49a5c863.svg";
export { ForwardRef as ReactComponent };